import React, {useState,useRef,useEffect} from "react";
import {Dropdown} from "react-bootstrap";

const currentYear = new Date().getFullYear();

const CustomYearDropdown = ({year,handleChange,dropdownIndex}) => {

    const HEIGHT_ITEM = 40;

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <p
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
                setTimeout(()=>{
                    document.getElementById(`list-${dropdownIndex}`).scroll({
                        top: (HEIGHT_ITEM * (currentYear - year)) - HEIGHT_ITEM,
                        // behavior: 'smooth'
                    });
                }, 10)
            }}
            className={'dropdown-select'}
        >
            {children}
            <img
                className="img-icon"
                src="/images/icon_arrowdown.svg"
                alt=""
            />
        </p>
    ));


    const CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            const [value, setValue] = useState('');

            return (
                <div
                    ref={ref}
                    style={style}
                    className={className}
                    aria-labelledby={labeledBy}
                    id={`list-${dropdownIndex}`}
                >
                    <ul className="list-unstyled">
                        {React.Children.toArray(children).filter(
                            (child) =>
                                !value || child.props.children.toLowerCase().startsWith(value),
                        )}
                    </ul>
                </div>
            );
        },
    );

    let html = [];
    for (let i = 0; i <= 100; i++) {
        html.push(i);
    }

    return(
        <Dropdown className={'custom-dropdown'} >
            <Dropdown.Toggle as={CustomToggle}>
                {year}년
            </Dropdown.Toggle>

            <Dropdown.Menu as={CustomMenu}>

                {html.map((item,index) => {
                    return (
                        <Dropdown.Item
                            key={index}
                            eventKey={currentYear - index}
                            onClick={(e)=>{
                                handleChange(currentYear - index,dropdownIndex);
                            }}
                            className={year === (currentYear-index) ? 'active' : ''}
                            // id={`drop-item-${dropdownIndex}-${year}`}
                        >
                            {currentYear-index}년
                        </Dropdown.Item>
                    )
                })}
            </Dropdown.Menu>
        </Dropdown>
    )
}

CustomYearDropdown.defaultProps  = {
    dropdownIndex : 0,
    year :  currentYear
}


export default CustomYearDropdown;
